import { inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';
import { DwSystemHttpErrorHandler } from './system-error';
import { GetloadingService } from './getloading.service';
var DwHttpClient = /** @class */ (function () {
    function DwHttpClient() {
        this.api = '';
        this.systemHttpError = inject(DwSystemHttpErrorHandler);
        this.http = inject(HttpClient);
        // this.initialize();
        this.load = inject(GetloadingService);
    }
    // protected abstract initialize(): void;
    DwHttpClient.prototype.errorHandler = function (error) { };
    DwHttpClient.prototype.responseIntercept = function (body) {
        return body;
    };
    Object.defineProperty(DwHttpClient.prototype, "defaultHeaders", {
        get: function () {
            return {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DwHttpClient.prototype, "defaultParams", {
        get: function () {
            return {};
        },
        enumerable: true,
        configurable: true
    });
    DwHttpClient.prototype.setThrowawayHeader = function (header) {
        this.throwawayHeader = header;
    };
    DwHttpClient.prototype.addDefaultOption = function (options) {
        var _this = this;
        var localOptions = options || {};
        var headers;
        if (localOptions.headers instanceof HttpHeaders) {
            headers = localOptions.headers;
        }
        else {
            headers = new HttpHeaders(localOptions.headers);
        }
        var localHeaders = this.throwawayHeader || this.defaultHeaders;
        this.throwawayHeader = undefined;
        headers = Object.keys(localHeaders)
            .reduce(function (acc, name) { return (acc.has(name)) ? acc : acc.set(name, localHeaders[name]); }, headers);
        var params;
        if (!!localOptions.params) {
            if (localOptions.params instanceof HttpParams) {
                params = localOptions.params;
            }
            else {
                params = new HttpParams({ fromObject: localOptions.params });
            }
        }
        params = Object.keys(this.defaultParams)
            .reduce(function (acc, name) { return (acc.has(name)) ? acc : acc.set(name, _this.defaultParams[name]); }, params);
        return {
            headers: headers,
            observe: localOptions.observe,
            params: params,
            body: localOptions.body,
            reportProgress: localOptions.reportProgress,
            responseType: localOptions.responseType,
            withCredentials: localOptions.withCredentials
        };
    };
    DwHttpClient.prototype.requestProcess = function (request) {
        var _this = this;
        return request.pipe(tap(function (response) { return response; }, function (error) {
            _this.systemHttpError.handlerError(error);
            _this.errorHandler(error);
        }), map(function (response) { return _this.responseIntercept(response); }));
    };
    DwHttpClient.prototype.request = function (method, url, options) {
        var requestOptions = this.addDefaultOption(options);
        var request = this.http.request(method, this.api + url, requestOptions);
        return this.requestProcess(request);
    };
    DwHttpClient.prototype.get = function (url, options) {
        var requestOptions = this.addDefaultOption(options);
        var request = this.http.get(this.api + url, requestOptions);
        return this.requestProcess(request);
    };
    DwHttpClient.prototype.post = function (url, body, options) {
        console.log(this.load, '加载');
        // this.load.getMask('',true)
        var requestOptions = this.addDefaultOption(options);
        var request = this.http.post(this.api + url, body, requestOptions);
        return this.requestProcess(request);
    };
    DwHttpClient.prototype.put = function (url, body, options) {
        var requestOptions = this.addDefaultOption(options);
        var request = this.http.put(this.api + url, body, requestOptions);
        return this.requestProcess(request);
    };
    DwHttpClient.prototype.delete = function (url, options) {
        var requestOptions = this.addDefaultOption(options);
        var request = this.http.delete(this.api + url, requestOptions);
        return this.requestProcess(request);
    };
    return DwHttpClient;
}());
export { DwHttpClient };
